import { styled, TextField } from '@mui/material';

import theme from 'core/ThemeConstants';

const StyledTextField = styled(TextField)(() => ({
  '& .MuiOutlinedInput-input': {
    border: `1px solid ${theme.black.default}`,
    fontSize: 14,
    minHeight: 35,
    fontWeight: 500,
    borderRadius: '0px',
    padding: '0px 1rem',
    color: theme.black.default,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '0px',
    borderColor: 'transparent',
    borderWidth: '1px !important',
  },
  '& .MuiInputBase-root': {
    backgroundColor: theme.white.default,
  },
}));

export default StyledTextField;
